function AddUser() {
  return <div>AddUser</div>;
}

export default AddUser;
